import { render, staticRenderFns } from "./ProofOfPayment.vue?vue&type=template&id=0ba8342c&"
import script from "./ProofOfPayment.vue?vue&type=script&lang=js&"
export * from "./ProofOfPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports